/** @jsx jsx */
import { jsx } from "theme-ui"
import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"
import styled from "@emotion/styled"
import Breadcrumb from "../components/breadcrumb"

const StyledArticle = styled.article`
  border-color: transparent;
  border-style: solid;
  border-width: 1px;
  border-radius: ${({ theme }) => theme.radii[3]}px;
  padding: ${({ theme }) => theme.space[2]}px ${({ theme }) => theme.space[4]}px;
  margin-bottom: ${({ theme }) => theme.space[4]}px;
  position: relative;
  z-index: 3;
  text-decoration: none;
  overflow: hidden;
  width: 100%;
  display: block;
  outline: none;
  box-shadow: 0 3px 8px 0 rgba(0, 0, 0, 0.03);
  background-color: ${(props) => props.theme.colors.paperBackgroundColor};
  border-color: ${(props) => props.theme.colors.paperBorderColor};
  color: ${(props) => props.theme.colors.articleTextColor};
`

const StyledSubHeading = styled.h2`
  margin-top: ${({ theme }) => theme.space[4]}px;
  margin-bottom: ${({ theme }) => theme.space[1]}px;
`

const StyledDescription = styled.p`
  margin: ${({ theme }) => theme.space[2]}px 0;
  color: ${(props) => props.theme.colors.articleDescriptionColor};
`

class ArticleTemplate extends React.Component {
  render() {
    const article = this.props.data.article
    const collection = article.fields.collection
    const section = article.fields.section

    return (
      <Layout location={this.props.location}>
        <Breadcrumb
          AllCollectionsText={
            this.props.data.site.siteMetadata.texts.allCollectionsText
          }
          CollectionSlug={collection.fields.slug}
          CollectionTitle={collection.title}
          Section={section}
          SectionTitle={section.title}
          ArticleTitle={article.frontmatter.title}
        />
        <StyledArticle>
          <header sx={{ mb: 3 }}>
            <StyledSubHeading>{article.frontmatter.title}</StyledSubHeading>
            <StyledDescription>
              {article.frontmatter.description}
            </StyledDescription>
          </header>
          <hr sx={{ background: "hsla(0,0%,0%,0.05)" }} />
          <section
            sx={{ pb: 4 }}
            dangerouslySetInnerHTML={{ __html: article.html }}
          />
        </StyledArticle>
      </Layout>
    )
  }
}

export default ArticleTemplate

export const Head = ({
  data: {
    article: {
      frontmatter: { title, description },
    },
  },
}) => {
  return <Seo title={`${title} | Probuild Support`} description={description} />
}

export const pageQuery = graphql`
  query ArticleBySlug($slug: String!) {
    site {
      siteMetadata {
        title
        texts {
          writtenByText
          allCollectionsText
          lastModifiedText
          publishedOnText
        }
        language
      }
    }
    article: markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      fields {
        section {
          id
          title
        }
        collection {
          id
          title
          fields {
            slug
          }
        }
      }
      frontmatter {
        title
        date
        modifiedDate
        description
        author {
          id
          name
          avatar {
            childImageSharp {
              fixed(width: 100, height: 100) {
                ...GatsbyImageSharpFixed
              }
            }
          }
        }
      }
    }
  }
`
